import { render, staticRenderFns } from "./SkillItem.vue?vue&type=template&id=0fa53674&scoped=true&"
import script from "./SkillItem.vue?vue&type=script&lang=js&"
export * from "./SkillItem.vue?vue&type=script&lang=js&"
import style0 from "./SkillItem.vue?vue&type=style&index=0&id=0fa53674&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa53674",
  null
  
)

export default component.exports